export default __webpack_public_path__ + "static/media/hk1.ab5905f4.jpg";